import PropTypes from 'prop-types';

import CardModule from '../../shared/card-module';
import TableBasic from '../../../atoms/table-basic/index';
import format from '../../../../utils/format';
import { className } from '../../../../utils/GlobalCssProxy';

const MarketCapitalization = ({ asOfDate, marketCapitalization, ticker }) => {
  const formattedMarketCaptalization =
    marketCapitalization && marketCapitalization.length
      ? marketCapitalization
      : [{ holdingName: '--', holdingPercent: 0 }];
  return (
    <CardModule
      data-analytics-componenttype="third-width-component"
      data-analytics-id="TW_MarketCapitalization"
      data-analytics-section="component"
    >
      <CardModule.Header>
        Market Capitalization
        <CardModule.AsOfDateMedBlock>{format.date(asOfDate)}</CardModule.AsOfDateMedBlock>
      </CardModule.Header>
      <CardModule.Body>
        <TableBasic flush>
          <caption {...className('sr-only')}>Market capitalization for {ticker}</caption>
          <thead>
            <tr>
              <th {...className('text-left')}>Investment</th>
              <th {...className('text-right')}>% of Equity Investments</th>
            </tr>
          </thead>
          <tbody>
            {formattedMarketCaptalization.map((item, index) => (
              <tr
                data-key={`${item.holdingName || ''}-${index}`}
                key={`${item.holdingName || ''}-${index}`}
              >
                <td>{format.text(item.holdingName)}</td>
                <td {...className('text-right', 'font-weight-bold')}>
                  {format.text(item.holdingName) === '--'
                    ? '--'
                    : format.percent(item.holdingPercent)}
                </td>
              </tr>
            ))}
          </tbody>
        </TableBasic>
      </CardModule.Body>
    </CardModule>
  );
};

MarketCapitalization.defaultProps = {
  asOfDate: '',
  marketCapitalization: [],
  ticker: ''
};

MarketCapitalization.propTypes = {
  asOfDate: PropTypes.oneOfType([PropTypes.instanceOf(Date), PropTypes.string]),
  marketCapitalization: PropTypes.arrayOf(
    PropTypes.shape({
      holdingName: PropTypes.string,
      holdingPercent: PropTypes.number
    })
  ),
  ticker: PropTypes.string
};

export default MarketCapitalization;
